(() => {
  if (window.Shopify?.designMode) return;

  const protectedMedia = (target) =>
    target instanceof Element && target.closest('img, picture, video');

  document.addEventListener(
    'contextmenu',
    (event) => {
      if (protectedMedia(event.target)) event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    (event) => {
      if (protectedMedia(event.target)) event.preventDefault();
    },
    true
  );
})();
